import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../ApiConfig';
import { showCustomAlert } from '../customalert';
import style from "../../css/admin/Totaluser.module.css";
import { getSecureToken } from '../ApisService/apiService';

const LIMIT = 20;

const User_subscribe = () => {
  const [users, setUsers] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const observer = useRef();

  const fetchUsers = async () => {
    if (loading || !hasMore) return;
    setLoading(true);
    const { secrettoken, ts } = await getSecureToken();
    try {
      const response = await axios.get(
        `${API_BASE_URL}Contact_us/User_subscrib.php?limit=${LIMIT}&offset=${offset}`,
        {
          headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
          withCredentials: true,
        }
      );
      if (response.data.status === 'success') {
        const newUsers = response.data.data || [];
        setUsers((prev) => [...prev, ...newUsers]);
        setOffset((prev) => prev + LIMIT);
        if (newUsers.length < LIMIT) setHasMore(false);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const lastRowRef = (node) => {
    if (loading || !hasMore) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchUsers();
      }
    });
    if (node) observer.current.observe(node);
  };

  const sendMessage = async () => {
    if (!message.trim()) {
      alert("Message cannot be empty!");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}Contact_us/Send_subscriber_message.php`, { message });
      if (response.data.status === "success") {
        showCustomAlert(response.data.message);
        setMessage("");
      } else {
        showCustomAlert("Failed to send the message.");
      }
    } catch (error) {
      console.error('Error sending message:', error);
      showCustomAlert("Failed to send the message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={style.container}>
      <h2 className={style.heading}>📬 Subscribers List</h2>

      {/* 📩 Message Box */}
      <div className={style.messageBox}>
        <textarea
          className={style.textArea}
          placeholder="Enter your message to all subscribers..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows="4"
        />
        <button
          onClick={sendMessage}
          className={style.sendButton}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
      </div>

      {/* 📊 Subscribers Table */}
      <div className={style.tableContainer}>
        <table className={style.userTable}>
          <thead>
            <tr>
              <th>#</th>
              <th>Email</th>
              <th>Subscribed Date</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((user, index) => {
                const isLast = index === users.length - 1;
                return (
                  <tr key={index} ref={isLast ? lastRowRef : null}>
                    <td>{index + 1}</td>
                    <td>{user.email}</td>
                    <td>{user.subscribed_at}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="3" className={style.noData}>
                  🚫 No subscribers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {loading && <p style={{ textAlign: 'center', padding: '1rem' }}>Loading more...</p>}
      </div>
    </div>
  );
};

export default User_subscribe;
